module.exports = __webpack_public_path__ + "static/img/thai_qr_img_6.875ff665.png";